// extracted by mini-css-extract-plugin
export default {"nsqf-info":"NSQF_nsqf-info__IznBQ","linkAnchor":"NSQF_linkAnchor__RArJ6"};